export default "__VITE_ASSET__Dfk_C4dJ__"